import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        mdred: "#ed1c24"
      },
      dark: {
        mdred: "#ed1c24"
      }
    }
  }
});
